module.exports = __webpack_public_path__ + "img/共時曆解讀星.5ec3a499.svg";